










































































































































































































import CompanySideCard from "@/components/company/CompanySideCard.vue";
import PersonSideCard from "@/components/person/PersonSideCard.vue";
import RepairEstimatePartyForm from "@/components/repair-estimate/RepairEstimatePartyForm.vue";
import SharedContentList from "@/components/shared-content/SharedContentList.vue";
import TemplateDialog from "@/components/template/TemplateDialog.vue";
import ConfirmActionDialog from "@/components/utility/ConfirmActionDialog.vue";
import CopyClipboardText from "@/components/utility/CopyClipboardText.vue";
import Debug from "@/components/utility/Debug.vue";
import MActionList from "@/components/utility/mmmint/MActionList.vue";
import MDetailTable, {
  DetailTableTypeEnum,
  DetailTableVisualizationEnum,
  IMDetailTableConfig
} from "@/components/utility/mmmint/MDetailTable.vue";
import MDetailViewGrid from "@/components/utility/mmmint/MDetailViewGrid.vue";
import MHeader, { IAction, IAlert, IChips } from "@/components/utility/mmmint/MHeader.vue";
import RefsInvoiceParty from "@/components/utility/RefsInvoiceParty.vue";
import RefsSelect from "@/components/utility/RefsSelect.vue";
import SelectAssignees from "@/components/utility/SelectAssignees.vue";
import { ActivityTypeEnum } from "@/lib/enum/activity-type.enum";
import { RequestStatusEnum } from "@/lib/enum/request-status-enum";
import { emailRule, phoneRuleOptional } from "@/lib/rules/contactRule";
import { requiredRule } from "@/lib/rules/requiredRule";
import { ClearanceGoToHelper } from "@/lib/utility/clearance.go-to-helper";
import { formatCurrency } from "@/lib/utility/currency-helper";
import { simpleDoubleDigitDate } from "@/lib/utility/date-helper";
import { handleError } from "@/lib/utility/handleError";
import { RepairEstimateGoToHelper } from "@/lib/utility/repair-estimate.go-to-helper";
import { $t } from "@/lib/utility/t";
import PartnerFallbackMixin from "@/mixins/PartnerFallbackMixin.vue";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import { Address } from "@/models/address.entity";
import { Clearance, IClearance } from "@/models/clearance.entity";
import { Company, ICompany } from "@/models/company.entity";
import { IPerson, Person } from "@/models/person.entity";
import { IReference } from "@/models/reference.entity";
import { ISharedContent } from "@/models/shared-content.entity";
import { ActionEnum } from "@/store/enum/authActionEnum";
import { BackendResourceEnum, ResourceEnum } from "@/store/enum/authResourceEnum";
import { PartnerModule } from "@/store/modules/partner";
import { PartnerUserModule } from "@/store/modules/partner-user.store";
import { RefsMessagesModule, RefTypeMap } from "@/store/modules/refs.store";
import { mixins } from "vue-class-component";
import { Component, Prop, Ref, Watch } from "vue-property-decorator";
import RefsSelected from "../utility/RefsSelected.vue";
import RefsVehicle from "../utility/RefsVehicle.vue";
import SelectEntity from "../utility/SelectEntity.vue";
import ClearanceDetailClearanceApprovalCard from "./ClearanceDetailClearanceApprovalCard.vue";
import ClearanceDetailForm from "./ClearanceDetailForm.vue";
import ClearanceShareDialog from "./ClearanceShareDialog.vue";

@Component({
  components: {
    MHeader,
    MDetailViewGrid,
    MDetailTable,
    ActivityCard: () => import("@/components/thg/ActivityCard.vue"),
    MActionList,
    ConfirmActionDialog,
    Debug,
    CopyClipboardText,
    RefsSelect,
    ClearanceShareDialog,
    RefsInvoiceParty,
    TemplateDialog,
    RepairEstimatePartyForm,
    PersonSideCard,
    CompanySideCard,
    ClearanceDetailForm,
    ClearanceDetailClearanceApprovalCard,
    SelectAssignees,
    RefsSelected,
    SelectEntity,
    RefsVehicle,
    SharedContentList
  },
  filters: {}
})
export default class ClearanceDetail extends mixins(PartnerFallbackMixin, PermissionMixin) {
  readonly RefsTypeMap = RefTypeMap;
  readonly Clearance = Clearance;
  readonly Address = Address;
  readonly DefaultTab = 0;
  readonly RefTypeMap = RefTypeMap;
  readonly RequestStatusEnum = RequestStatusEnum;

  @Ref("clearanceShareDialog")
  clearanceShareDialog!: ClearanceShareDialog;

  @Prop()
  value!: IClearance;

  @Prop()
  hideBreadCrumbs!: boolean;

  @Prop()
  showDetailButton!: boolean;

  isDeleteDialogActive = false;

  isDeleteLoading = false;

  isLoadingRefs = false;

  isAcceptDialog = false;

  sharedContent: ISharedContent[] = [];

  personSideCard: IPerson | null = null;

  companySideCard: ICompany | null = null;

  tab = 0;

  get context() {
    return {
      clearanceApproval: this.value,
      report: this.value.report,
      vehicle: this.value.report?.vehicle
    };
  }

  get alerts(): IAlert[] {
    const alerts: IAlert[] = [];

    return alerts;
  }

  get attachmentFileFilters() {
    return this.value?.report?.refFilter || [];
  }

  get chips(): IChips[] {
    const chips: IChips[] = [];

    chips.push({
      key: "createdReadable",
      text: this.value.timestamp.createdReadable
    });

    chips.push({
      text: $t(`enums.RequestStatusEnum.${this.value.status}`),
      color: this.value.statusColor,
      key: "updatedReadable"
    });

    if (this.value.subTotal) {
      chips.push({
        text: formatCurrency(this.value.subTotal, this.value.currency),
        color: "success",
        key: "subTotal"
      });
    }

    return chips;
  }

  get refsCategories(): BackendResourceEnum[] {
    return this.value.refsCategories;
  }

  get requiredRule() {
    return [requiredRule()];
  }

  get emailRule() {
    return [requiredRule(), emailRule()];
  }

  get phoneRule() {
    return [phoneRuleOptional()];
  }

  get subtitle() {
    return $t("createdOn", { date: simpleDoubleDigitDate(this.value.timestamp.created) });
  }

  get breadCrumbs() {
    if (this.hideBreadCrumbs) {
      return undefined;
    }
    const breadCrumbs = ClearanceGoToHelper.breadCrumbs;

    const selected = [];

    selected.push(breadCrumbs.ClearanceTable(this.value.partnerId));
    selected.push(breadCrumbs.ClearanceDetail(this.value.partnerId, this.value.id));

    return selected;
  }

  get actions(): IAction[] {
    const actions: IAction[] = [];

    if (this.showDetailButton) {
      actions.push({
        text: $t("common.nouns.detail"),
        key: "detail",
        icon: "mdi-open-in-new",
        color: "",
        exec: () =>
          new ClearanceGoToHelper(this.$router).goToClearanceDetail({
            partnerId: this.value.partnerId,
            clearanceId: this.value.id,
            newTab: false
          })
      });
    }

    if (this.sharedContent.length) {
      actions.push({
        text: $t("timeLine.ReportActivityBoxShareComponent.copy"),
        key: "copy",
        icon: "mdi-copy",
        color: "",
        exec: () => this.sharedContent[0].copyLinkToClipboard()
      });
    }

    if (this.value.status === RequestStatusEnum.DRAFT) {
      actions.push({
        text: $t("common.verbs.share"),
        key: "detail",
        icon: "mdi-share",
        color: "",
        exec: () => this.clearanceShareDialog?.open(this.sharedContent[0])
      });
    }

    return actions;
  }

  get bottomActions() {
    const actions: IAction[] = [];

    if (this.showDetailButton) {
      actions.push({
        text: $t("common.nouns.detail"),
        key: "detail",
        icon: "mdi-open-in-new",
        color: "",
        exec: () =>
          new ClearanceGoToHelper(this.$router).goToClearanceDetail({
            partnerId: this.value.partnerId,
            clearanceId: this.value.id,
            newTab: false
          })
      });
    }

    if (this.can(ActionEnum.DELETE, BackendResourceEnum.CLEARANCE_APPROVAL)) {
      actions.push({
        text: $t("delete"),
        key: "title",
        icon: "mdi-trash-can",
        color: "red",
        exec: this.onDeleteItem
      });
    }

    return actions;
  }

  get partner() {
    return PartnerModule.partner;
  }

  get source() {
    return {
      refId: this.value.id,
      refType: BackendResourceEnum.CLEARANCE_APPROVAL
    };
  }

  get to() {
    if (this.value.seller?.email) {
      return [this.value.seller.email];
    }
    return [];
  }

  get detailTableConfig(): IMDetailTableConfig[] {
    return [
      {
        key: "title",
        type: DetailTableTypeEnum.PROPERTY,
        visualization: DetailTableVisualizationEnum.TEXT
      },
      {
        key: "subTotal",
        type: DetailTableTypeEnum.PROPERTY,
        visualization: DetailTableVisualizationEnum.TEXT
      },
      {
        key: "total",
        type: DetailTableTypeEnum.PROPERTY,
        visualization: DetailTableVisualizationEnum.TEXT
      }
    ];
  }

  async mounted() {
    RefsMessagesModule.generateFrontendTimeLineElementsForMessagesAssociatedWithReference({
      refId: this.value.id,
      partnerId: this.value.partnerId
    });

    this.fetchReportAndVehicle();
  }

  @Watch("value.reportId", { deep: true })
  async fetchReportAndVehicle() {
    await this.value.fetchReportAndVehicle().catch(this.$log.error);
  }

  onDeleteItem() {
    this.isDeleteDialogActive = true;
  }

  getUserNameForId(id: string) {
    const user = PartnerUserModule.maps.id.get(id)[0];

    let name = "";
    if (user) {
      name = `${user.firstName} ${user.lastName}`;
    }

    return name;
  }

  async onDelete() {
    try {
      this.isDeleteLoading = true;

      await this.value.delete();

      this.$toast.success("👍");

      this.isDeleteDialogActive = false;

      this.$emit("deleted");
    } catch (e) {
      handleError(e);
    } finally {
      this.isDeleteLoading = false;
    }
  }

  async saveRefs() {
    this.isLoadingRefs = true;
    await this.value
      .updatePartial({
        refs: this.value.refs
      })
      .catch(handleError);
    this.isLoadingRefs = false;
  }

  openBuyerSellerSideCard(ref?: IReference) {
    if (!ref) {
      return;
    }

    if (ref.refType === ResourceEnum.PERSON) {
      const element = new Person({
        id: ref.refId,
        partnerId: this.value.partnerId
      });
      this.personSideCard = element;
    } else if (ref.refType === ResourceEnum.COMPANY) {
      const element = new Company({
        id: ref.refId,
        partnerId: this.value.partnerId
      });
      this.companySideCard = element;
    }
  }

  async resetStateBackToRequested() {
    await this.value
      .updatePartial({
        status: RequestStatusEnum.REQUESTED
      })
      .catch(handleError);
  }

  async onAssigneesUpdate(assignees: []) {
    if (!this.value) return;

    await this.value.updatePartial({ assignees });
  }

  async onAssigneesAdded(assignees: string[]) {
    if (!this.value) return;

    await this.value.createAssigneeActivity(ActivityTypeEnum.CREATE_ASSIGNEE, assignees);
  }

  async onAssigneesRemoved(assignees: string[]) {
    if (!this.value) return;

    await this.value.createAssigneeActivity(ActivityTypeEnum.DELETE_ASSIGNEE, assignees);
  }

  goToClearanceApproval(clearanceApprovalId: string) {
    new ClearanceGoToHelper(this.$router).goToClearanceDetail({
      partnerId: this.value.partnerId,
      clearanceId: clearanceApprovalId
    });
  }

  goToRepairEstimate(repairEstimateId: string) {
    new RepairEstimateGoToHelper(this.$router).goToRepairEstimateDetail({
      partnerId: this.value.partnerId,
      repairEstimateId: repairEstimateId
    });
  }

  onSharedContentUpdate(list: ISharedContent[]) {
    this.sharedContent.splice(0);
    this.sharedContent.push(...list);
  }
}
